import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import * as actions from '../actions/TablaBuquesActions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_EDICION_BUQUE } from '../../../config/forms'
import { CircularProgress } from '@material-ui/core'
import { INTERVALO_CORTO } from '../../../config/settings'
import { ToastContainer } from 'react-toastify'
import CamposBuque from './CamposBuque'

class DialogoBuqueUpdate extends Component {
  componentDidMount () {
    const { nombre } = this.props
    this.props.getConsultaBuque(nombre)
  }

  render () {
    const {
      consultaBuque,
      change: formChange
    } = this.props

    if (consultaBuque) {
      formChange('nombreCorto', consultaBuque.nombreCorto)
      formChange('nombreCortoInicial', consultaBuque.nombreCorto)
      formChange('nombre', consultaBuque.nombre)
      formChange('eslora', consultaBuque.eslora)
      formChange('manga', consultaBuque.manga)
      formChange('puntal', consultaBuque.puntal)
      formChange('calado', consultaBuque.calado)
      formChange('pesoBruto', consultaBuque.pesoBruto)
      formChange('pesoDeDesplazamiento', consultaBuque.pesoDeDesplazamiento)
      formChange('velocidadMaxima', consultaBuque.velocidadMaxima)
      formChange('velocidadMedia', consultaBuque.velocidadMedia)
      formChange('atis', consultaBuque.atis)
      formChange('mmsi', consultaBuque.mmsi)
      formChange('imo', consultaBuque.imo)
      formChange('pais', consultaBuque.bandera)
    }

    return (
      <div>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <Card style={{ border: 'none' }}>
          {!consultaBuque && <div style={{ padding: '10% 0', margin: '0 auto' }} >
            <CircularProgress />
          </div> }
          <Card.Body>
            {consultaBuque && <div className='flex-nowrap container-condicion-recalado' >
              <CamposBuque />
            </div> }
          </Card.Body>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaBuque: state.buque.consultaBuque
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_EDICION_BUQUE,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoBuqueUpdate))
